const Unite = () => import('@/page/Unite')

const Material = () => import("@/page/unite/material");
const Analysis = () => import("@/page/unite/analysis");
const QuestionsPreview = () => import("@/page/unite/questionsPreview");
const Paperpreview = () => import("@/page/unite/paperpreview");
const Prerelease = () => import("@/page/unite/Prerelease");
const myspace = () => import("@/page/unite/myspace");
const personalInformation = () => import("@/page/unite/personalInformation");
const AnalysisUnite = () => import("@/page/unite/analysisUnite");
const AnalysisSpecial = () => import("@/page/unite/analysisSpecial");
const OnlineCard = () => import("@/page/unite/OnlineCard");
const OnlineCardDeatail = () => import("@/page/unite/OnlineCardDeatail");
const schoolmaterial = () => import("@/page/unite/schoolmaterial");//校本题库
const personmaterial = () => import("@/page/unite/personmaterial");//个人题库
const uploadPaper = () => import("@/page/unite/uploadPaper");
const testQuestion = () => import("@/page/unite/testQuestion");
const zuobiao = () => import("@/page/unite/zuobiao");//坐标
const moban = () => import("@/page/unite/moban");//
const answerZuobiao = () => import("@/page/unite/answerZuobiao");//坐标
const OnlineCardDetailNew = () => import("@/page/unite/OnlineCardDetailNew");//
export default {
  path: "/unite",
  component: Unite,
  children: [{
      path: "material",
      name: "material",
      component: Material
    },
    {
      path: "analysis",
      name: "analysis",
      component: Analysis
    },
    {
      path: "questionsPreview",
      name: "questionsPreview",
      component: QuestionsPreview
    },
    {
      path: "paperpreview",
      name: "paperpreview",
      component: Paperpreview
    },
    {
      path: "Prerelease",
      name: "Prerelease",
      component: Prerelease
    },
    {
      path: "myspace",
      name: "myspace",
      component: myspace
    },
    {
      path: "analysisUnite",
      name: "analysisUnite",
      component:AnalysisUnite
    },
    {
      path: "analysisSpecial",
      name: "analysisSpecial",
      component:AnalysisSpecial
    },
    {
      path: "onlinecard",
      name: "onlinecard",
      component:OnlineCard
    },
    {
      path: "CardDeatail",
      name: "CardDeatail",
      component:OnlineCardDeatail
    },
    {
      path: "schoolmaterial",
      name: "schoolmaterial",
      component:schoolmaterial
    },
    {
      path: "personmaterial",
      name: "personmaterial",
      component:personmaterial
    },
    {
      path: "uploadPaper",
      name: "uploadPaper",
      component:uploadPaper
    },
    {
      path: "testQuestion",
      name: "testQuestion",
      component:testQuestion
    },
    {
      path: "zuobiao",
      name: "zuobiao",
      component:zuobiao
    },
    {
      path: "moban",
      name: "moban",
      component:moban
    },
    {
      path: "/unite/personalInformation",
      name: "personalInformation",
      component: personalInformation
    },
    {
      path: "answerZuobiao",
      name: "answerZuobiao",
      component: answerZuobiao
    },
    {
      path: "OnlineCardDetailNew",
      name: "OnlineCardDetailNew",
      component: OnlineCardDetailNew
    },
  ]
};



// WEBPACK FOOTER //
// ./src/router/unite.js